/*
 * Lumeer: Modern Data Definition and Processing Platform
 *
 * Copyright (C) since 2017 Lumeer.io, s.r.o. and/or its affiliates.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';

import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {AppState} from '../../store/app.state';
import {Collection} from '../../store/collections/collection';
import {WorkspaceService} from '../../../workspace/workspace.service';
import {ResourcesGuardService} from '../../../workspace/resources-guard.service';

@Injectable()
export class CollectionsGuard implements Resolve<Collection[]> {
  constructor(
    private store$: Store<AppState>,
    private workspaceService: WorkspaceService,
    private resourcesGuardService: ResourcesGuardService
  ) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Collection[]> {
    const organizationCode = route.paramMap.get('organizationCode');
    const projectCode = route.paramMap.get('projectCode');

    return this.workspaceService
      .selectOrGetWorkspace(organizationCode, projectCode)
      .pipe(
        mergeMap(({organization, project}) => this.resourcesGuardService.selectCollections$(organization, project))
      );
  }
}
